import { FieldHtmlNameUtil, FieldHtmlNameType } from 'www-shared';
import GatedContentProgressiveProfileDefinition from './GatedContentProgressiveProfileDefinition';

/** Defines that fields to show, the name of the branch to consider and hide/show rules */
export default class PhoneGatedContentProgressiveProfileDefinition extends GatedContentProgressiveProfileDefinition {
  public getAlwaysShownFields(): readonly FieldHtmlNameType[] {
    const alwaysShow = [...super.getAlwaysShownFields(), FieldHtmlNameUtil.phoneNumber];

    return alwaysShow;
  }
}
